<template>
    <div id="TopNav">
        <mu-appbar v-if="$store.state.headerDisp" :z-depth="0" color="white" class="top_nav" :style="{left: !$store.state.menuExpand? '240px':'64px'}">
            <mu-button small icon slot="left" style="margin-left:32px;" color="grey" @click="menuExpand" :title="$t('common.menuExpand')">
                <mu-icon :value="!$store.state.menuExpand? 'format_indent_decrease':'format_indent_increase'" :size="24"></mu-icon>
            </mu-button>
            <mu-button v-show="$store.state.logOutDisp" small icon slot="left" color="grey" style="margin-left:32px;" @click="openRegisterTip(true)" v-if="showTipButton" :title="$t('common.showTip')">
                <mu-icon value="lightbulb_outline" :size="24"></mu-icon>
            </mu-button>
            <mu-button small icon slot="left" color="grey" style="margin-left:32px;" @click="refreshPage" v-if="hasRefresh" :title="$t('common.refresh')">
                <mu-icon value="refresh" :size="24"></mu-icon>
            </mu-button>
            <Notifications v-if="notifications" slot="left"/>

            <mu-menu v-show="$store.state.logOutDisp" slot="right" open-on-hover :open.sync="openLang">
                <mu-button color="primary" flat small>
                  <img :src="selectLang.img" style="margin-right:6px;width:28px"/>
                </mu-button>
                <mu-list slot="content">
                  <mu-list-item avatar button v-for="language in languages" :key="language.key"
                    @click="changeLang(language)">
                    <mu-list-item-action>
                      <mu-avatar><img :src="language.img"/></mu-avatar>
                    </mu-list-item-action>
                    <mu-list-item-title> {{language.name}}</mu-list-item-title>
                  </mu-list-item>
                </mu-list>
            </mu-menu>
            <mu-menu v-show="$store.state.logOutDisp" slot="right" open-on-hover>
                <mu-button flat small color="grey" style="text-transform: none;"><mu-icon value="person" left ></mu-icon>{{$store.state.user.name}}<mu-icon value="arrow_drop_down" right></mu-icon></mu-button>
                <mu-list slot="content" class="profile_menu">
                    <mu-list-item button small to="/profile">
                        <mu-icon value="person" style="margin-right:6px;"></mu-icon>
                        <mu-list-item-title color="grey">{{$t('common.userCenter')}}</mu-list-item-title>
                    </mu-list-item>
                    <mu-list-item button @click="logout">
                        <mu-icon value="exit_to_app" style="margin-right:6px;"></mu-icon>
                        <mu-list-item-title>{{$t('common.logout')}}</mu-list-item-title>
                    </mu-list-item>
                </mu-list>
            </mu-menu>
        </mu-appbar>
        <mu-dialog width="1024" max-width="80%" :esc-press-close="false" :overlay-close="false"
            :open.sync="openShowTip" transition="slide-top" class="tip_dialog">
<!--            <mu-button icon @click="closeShowTip" class="colse_dlg_btn"><img src="/mdmEn/static/images/ico_banner_close.png"></mu-button>-->
            <mu-button icon @click="closeShowTip" class="colse_dlg_btn"><img src="/mdm/static/images/ico_banner_close.png"></mu-button>
            <mu-carousel :active="activeTipStep" :interval="0" :cycle="false" :hide-indicators="true" :hide-controls="true">
                <mu-carousel-item>
                    <mu-flex class="carousel_item" direction="column" align-items="center">
                        <mu-flex class="step_info">
                            <mu-flex direction="column" justify-content="center" align-items="center" class="text">
                                <h3>1</h3>
                                <span>{{$t('tips.tip_title_1')}}</span>
                            </mu-flex>
                        </mu-flex>
                        <img :src="carouselImg1" class="carousel_img"/>
                        <mu-flex align-items="center" justify-content="between" class="tip_msg_block">
                            <mu-flex style="width: 85%;" align-items="center">
                                <mu-icon value="play_arrow" color="grey" style="margin-right:4px;"></mu-icon>
                                <p class="tip_msg">{{$t('tips.tip_msg_1')}}</p>
                            </mu-flex>
                            <mu-flex>
                                <mu-button icon color="grey" @click="activeTipStep = 3"><mu-icon value="arrow_back"></mu-icon></mu-button>
                                <mu-button icon color="grey" @click="activeTipStep ++"><mu-icon value="arrow_forward"></mu-icon></mu-button>
                            </mu-flex>
                        </mu-flex>
                    </mu-flex>
                </mu-carousel-item>
                <mu-carousel-item>
                    <mu-flex class="carousel_item" direction="column" align-items="center">
                        <mu-flex class="step_info">
                            <mu-flex direction="column" justify-content="center" align-items="center" class="text">
                                <h3>2</h3>
                                <span>{{$t('tips.tip_title_2')}}</span>
                            </mu-flex>
                        </mu-flex>
                        <img :src="carouselImg2" class="carousel_img"/>
                        <mu-flex align-items="center" justify-content="between" class="tip_msg_block">
                            <mu-flex align-items="center" style="width: 85%;">
                                <mu-icon value="play_arrow" color="grey" style="margin-right:4px;"></mu-icon>
                                <p class="tip_msg">{{$t('tips.tip_msg_2')}}</p>
                            </mu-flex>
                            <mu-flex>
                                <mu-button icon color="grey" @click="activeTipStep --"><mu-icon value="arrow_back"></mu-icon></mu-button>
                                <mu-button icon color="grey" @click="activeTipStep ++"><mu-icon value="arrow_forward"></mu-icon></mu-button>
                            </mu-flex>
                        </mu-flex>
                    </mu-flex>
                </mu-carousel-item>
                <mu-carousel-item>
                    <mu-flex class="carousel_item" direction="column" align-items="center">
                        <mu-flex class="step_info">
                            <mu-flex direction="column" justify-content="center" align-items="center" class="text">
                                <h3>3</h3>
                                <span>{{$t('tips.tip_title_3')}}</span>
                            </mu-flex>
                        </mu-flex>
                        <img :src="carouselImg3" class="carousel_img"/>
                        <div ref="desc_qrCode" class="qrcode"></div>
                        <mu-flex align-items="center" justify-content="between" class="tip_msg_block">
                            <mu-flex align-items="center" direction="column" style="width: 85%;">
                                <mu-flex align-items="center">
                                    <mu-icon value="play_arrow" color="grey" style="margin-right:4px;"></mu-icon>
                                    <p class="tip_msg">{{$t('tips.tip_msg_3_1')}}</p>
                                </mu-flex>
                                <mu-flex align-items="center">
                                    <p class="tip_msg">{{$t('tips.tip_msg_3_2')}}
                                    <mu-icon value="flip" :size="18" color="info" style="margin:0px 4px;"></mu-icon>（{{$t('tips.tip_msg_3_3')}}</p>
                                </mu-flex>
                            </mu-flex>
                            <mu-flex>
                                <mu-button icon color="grey" @click="activeTipStep --"><mu-icon value="arrow_back"></mu-icon></mu-button>
                                <mu-button icon color="grey" @click="activeTipStep ++"><mu-icon value="arrow_forward"></mu-icon></mu-button>
                            </mu-flex>
                        </mu-flex>
                    </mu-flex>
                </mu-carousel-item>
                <mu-carousel-item>
                    <mu-flex class="carousel_item" direction="column" align-items="center">
                        <mu-flex class="step_info">
                            <mu-flex direction="column" justify-content="center" align-items="center" class="text">
                                <h3>4</h3>
                                <span>{{$t('tips.tip_title_4')}}</span>
                            </mu-flex>
                        </mu-flex>
                        <img :src="carouselImg4" class="carousel_img"/>
                        <mu-flex align-items="center" justify-content="between" class="tip_msg_block">
                            <mu-flex align-items="center" style="width: 95%;">
                                <mu-icon value="play_arrow" color="grey" style="margin-right:4px;"></mu-icon>
                                <span class="tip_msg">{{$t('tips.tip_msg_4_1')}}</span>
                                <mu-button flat color="info" to="/device/information">
                                    <mu-icon value="devices" color="info" :size="18" left></mu-icon>
                                    {{$t('groupTitle.name')}}
                                    <mu-icon value="play_arrow" color="grey" :size="18"></mu-icon>
                                    {{$t('device.equipmentInformationManagement')}}
                                </mu-button>
                                <span class="tip_msg">{{$t('tips.tip_msg_4_2')}}</span>
                            </mu-flex>
                            <mu-flex>
                                <mu-button icon color="grey" @click="activeTipStep --"><mu-icon value="arrow_back"></mu-icon></mu-button>
                                <mu-button icon color="grey" @click="activeTipStep = 0"><mu-icon value="arrow_forward"></mu-icon></mu-button>
                            </mu-flex>
                        </mu-flex>
                    </mu-flex>
                </mu-carousel-item>
            </mu-carousel>
        </mu-dialog>
    </div>
</template>
<script>
import carouselImg1 from '@/assets/image/tip/mdm_register1.jpg';
import carouselImg2 from '@/assets/image/tip/mdm_register2.jpg';
import carouselImg3 from '@/assets/image/tip/mdm_register3.jpg';
import carouselImg4 from '@/assets/image/tip/mdm_register4.jpg';
import androidLogo from '@/assets/image/tip/mdm_android_logo.png';
import {customerInfo} from "@/api/customer/customer";
import { userLogin,userLoginOut} from "@/api/system/login";
import QRCode from 'qrcodejs2';
import Notifications from "./notifications"

import chineseFlag from '@/assets/image/chinese_flag.png';
import englishFlag from '@/assets/image/english_flag.png';
export default {
    name: "TopNav",
    components:{Notifications},
    data() {
        return {
            carouselImg1,
            carouselImg2,
            carouselImg3,
            carouselImg4,
            androidLogo,
            openShowTip:false,
            showTipButton: false,
            activeTipStep: 0,
            customerInfo: {},
            selectLang: {},
            openLang: false,
            languages: [
                {key: 'zh-CN', name: '简体中文', img: chineseFlag},
                {key: 'en', name: 'English', img: englishFlag}
            ],
        }
    },
    props: {
        hasRefresh: {
            type: Boolean,
            default: false
        },
        refreshPage: {
            type: Function,
            default: null
        },

        notifications:{
            type: Boolean,
            default: false
        }
    },
    async mounted() {
        await this.$onWait;
        customerInfo({
            id: this.$store.state.user.custId
        }).then(res => {
            if (res.code == 200) {
                if (res.data && res.data.bianma) {
                    this.showTipButton = true;
                    this.customerInfo = res.data;
                    if (this.$store.state.showTip) {
                        this.openRegisterTip();
                    }
                } else {
                    this.showTipButton = false;
                }

            } else {
                this.showTipButton = false;
            }
        });
        console.log("TOPBAR:", this.$store.state.lang);
        if (this.$store.state.lang == 'zh-CN' || this.$store.state.lang == 'zh' ) {
            this.selectLang = this.languages[0];
        } else {
            this.selectLang = this.languages[1];
        }
    },
    methods: {
        menuExpand() {
            console.log(this.$store.state.menuExpand);
            this.$store.commit("change_menuExpand");
        },
        closeShowTip() {
            this.openShowTip = false;
            this.$store.commit("close_showTip");
        },
        changeActive (index) {
            this.active = index;
        },
        openRegisterTip(status) {
            if ($isNull(status)) {
                if (this.$store.state.inIframe == true) {
                    return;
                }
                
                if (this.$store.state.accessKey == true) {
                    var showTipUserId = "showTip-" + this.$store.state.user.id;
                    console.log("TopNav.vue openRegisterTip", showTipUserId, localStorage.getItem(showTipUserId));
                    if ($isNotNull(localStorage.getItem(showTipUserId))) {
                        return;
                    } else {
                        localStorage.setItem(showTipUserId, "showTip");
                    }
                }
            }

            this.openShowTip = true;
            var self = this;
            self.$nextTick(function() {
                self.$refs.desc_qrCode.innerHTML = '';
                new QRCode(self.$refs.desc_qrCode, {
                    text: self.customerInfo.bianma + "," + this.$store.state.user.id,
                    width: 240,
                    height: 240,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })
            });
        },
        changeLang(locate) {
            this.selectLang = locate;
            if (locate.key == 'zh-CN' || locate.key == 'zh') {
                this.$i18n.locale = locate.key;
                this.$store.commit("set_lang", locate.key);
            } else {
                this.$i18n.locale = 'en';
                this.$store.commit("set_lang", 'en');
            }
            this.openLang = false;
            this.$forceUpdate();
        },
        logout() {
            this.$confirm(this.$t("common.confrimLogout"), this.$t("common.tips"),{
                okLabel: this.$t('button.confirm'),
                cancelLabel: this.$t("button.cancel"),
                type: "warning"
            }).then(result =>{
                if(result.result){
                    userLoginOut().then(res =>{
                    this.$store.commit("del_token");
                    this.$router.replace('/');
                    })


                }
            })

        }
    }
}
</script>
<style scoped>
.top_nav {
    position: fixed;
    left:0px;
    right:0px;
    top:0px;
    z-index: 999;
}
.carousel_item {
    width:100%;
    position: relative;
}
.carousel_item .step_info {
    position: absolute;
    top:-22px;
    left:48px;
    /*background-image: url('/mdmEn/static/images/pic_banner_tag.png') ;*/
    background-image: url('/mdm/static/images/pic_banner_tag.png') ;
    background-size: 100% 100%;
    height:126px;
    width:76px;
}
.carousel_item .carousel_img {
    width:100%;
    height: auto;
    margin-top:8px;
    box-shadow:0px 8px 12px 0px rgba(77,104,149,0.29);
    border-radius:16px;
}
.carousel_item .step_info .text {
    position: absolute;
    height:100%;
    width:100%;
    justify-content: center;
    align-items: center;
}
.carousel_item .step_info .text h3 {
    font-size:24px;
    font-family: 'DINCOND';
    color:#fff;
    margin:0px;
}
.carousel_item .step_info .text span {
    font-size:16px;
    font-family: 'DINCOND';
    color:#fff;
}
.carousel_item .tip_msg_block {
    margin:0px 6%;
    width: 88%;
    height: 105px;
    padding: 0px 46px;
    background: #fff;
    box-shadow:0px 2px 8px 0px rgba(77,104,149,0.1);
    border-radius:0px 0px 8px 8px;
}
.carousel_item .tip_msg {
    font-size:14px;
    font-family: 'DINCOND';
    color:#20253A;
    margin-top:0px;
    margin-bottom:0px;
    line-height: 32px;
    text-align:center;
}
.carousel_item .qrcode {
    position: absolute;
    width:240px;
    height:240px;
    left:60%;
    top:64px;
}
.colse_dlg_btn {
    position: absolute;
    right: 16px;
    top:16px;
    z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue